export enum DonationCharityState {
  unassigned = 'unassigned',
  assigned = 'assigned',
  accepted = 'accepted',
  declined = 'declined',
  canceled = 'canceled',
}
